import React, { Component } from 'react';
import './../css/Actividad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { faHome, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from 'react-bootstrap-table-next';
import { ReactComponent as EditarIcon } from './../../img//svg/Editar.svg';
import { ReactComponent as EliminarIcon } from './../../img//svg/Eliminar.svg';
import enviar from './../../img/svg/Enviar(blanco).svg';
 
export class Solicitud_materia extends Component {
    static displayName = Solicitud_materia.name;

    constructor(props) {
        super(props);
        this.state = {
            materias: [], materia: {
                idcurso: 0, porc: 0, anio: "", term: "", termino: "", codigomateria: "", nommateria: "", numhorasteoricas: 0, numhoraspracticas: 0, paralelo: 0, idtipoactividad: 0,
                observacion: "", fechaInicio: "", fechaFin: "", valorevaluacion: 0, valornumexam: 0, estadocheck: "", tipoprofesor: ""
            },  observacion: "", pao1: "", pao2: "", pae: "", accion: "", loading: false, loading2: false
        };
        this.onInputChange = this.onInputChange.bind(this); 
        this.agregarSolicitud = this.agregarSolicitud.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
    }

    componentDidMount() {
    }
    //funcion para click en update delete
    handleClick = (text) => {
        this.setState({
            accion: text,
        });
    }
    onChangeValue(event) { 
        this.setState({
            accion: event.target.value,
        });
    }

    onInputChange(event) {
        var control = event.target.name;
        if (control === "review") {
            var value = this.state.observacion;
            value = event.target.value;
            this.setState({
                observacion: value
            });
        } 
        //this.props.updatestate_mat(this.props.idcurso, this.state.observacion, this.state.termino, this.state.accion)
    }
     
    agregarSolicitud(event) { 
        event.preventDefault();
        this.props.updatestate(this.props.idcurso,
            this.props.descripcion, this.state.observacion,
            this.props.anio, this.props.termino, this.props.totalhoras,
            this.state.accion)
    } 
    render() {

        const estilo = {
            color: 'white',
            fontSize: '10px',
        };


        return (
            <div>
                <div className="box2 sb9"><table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr className='tr-tablexpand-header'>
                            <th className='tr-descr-header'></th>
                            <th className='tr-obser-header'></th>
                            <th className='tr-perio-header'></th>
                            <th className='tr-accio-header'></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td className='td-descr-header'>Materia</td>
                            <td className='td-obser-header'>Observacion</td>
                            <td className='td-perio-header'>Periodo</td>
                            <td className='td-accio-header'>Acciones</td>
                        </tr>
                        <tr>
                            <td>{this.props.descripcion}</td>
                            <td><textarea id="review" name="review" className='area_width' value={this.state.observacion} onChange={this.onInputChange}></textarea></td>
                            <td>
                                {this.props.termino}
                            </td>
                            <td> 

                                <div onChange={this.onChangeValue}>

                                    <div className="form-check-despl">
                                        <FontAwesomeIcon icon={faEdit} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Modificar Carga")} style={this.state.accion === "Modificar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />
                                        &nbsp;&nbsp;|&nbsp;&nbsp;
                                        <FontAwesomeIcon icon={faTrash} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Eliminar Carga")} style={this.state.accion === "Eliminar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />
                                    </div>
                                     
                                </div>
                               

                                <div>
                                    <button type="button" className="btn btn-sm btn-info btn-agregar" onClick={this.agregarSolicitud}>    {/* funcion para guardar la solicitud y enviar a la unificada*/}
                                        <img width="24px" height="24px" src={enviar} />Agregar Solicitud</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table></div>

            </div>
        );
    }

}